module.exports = __webpack_public_path__ + "static/media/43-iveco.c18b3e77.jpg";